import { TWidget } from 'widgets/Widget';
import localStorageWrapper from 'widgets/toolbox/localStorageWrapper';

declare global {
    interface Window {
        BindIDme?: () => void;
    }
}

/**
 * @description Base IdmeCard implementation
 * @param Widget Base widget for extending
 * @returns IdmeCard class
 */
function IdmeCardClassCreator(Widget: TWidget) {
    /**
     * @category widgets
     * @subcategory global
     * @class IdmeCard
     * @augments Widget
     * @property {string} data-widget - Widget name `idmeCard`
     */

    class IdmeCard extends Widget {
        prefs() {
            return {
                verified: false,
                idmeButton: 'idme-wallet-button',
                ...super.prefs()
            };
        }

        init() {
            super.init();

            this.checkVerificationStatus();

            this.eventBus().on('cart.updated', 'rebindIdme');
        }

        rebindIdme() {
            if (document.getElementById(this.prefs().idmeButton)) {
                window.BindIDme?.();
            }
        }

        /**
         * @description Pushes properly formatted events to dataLayer
         * @param eventName the event name
         */
        pushToDataLayer(eventName): void {
            window.dataLayer?.push({
                event: 'ga4_event',
                event_name: eventName,
                [eventName]: {
                    feature: 'ID_me'
                }
            });
        }

        /**
         * @description Handles click events inside the ID.me widget, if the click is on "verify" button, pushes an event to the dataLayer
         * @param _ - Unused
         * @param event - Click event
         */
        handleClick(_, event) {
            if (event.target?.closest('.idme-trigger-link')) {
                this.pushToDataLayer('verification_start');
            }
        }

        /**
         * @description Checks verification status and pushes an event to the dataLayer if newly verified
         */
        checkVerificationStatus() {
            const verified = this.prefs().verified;

            if (verified && localStorageWrapper.getItem('idmeVerified') !== 'true') {
                this.pushToDataLayer('verification_success');
            }

            localStorageWrapper.setItem('idmeVerified', verified.toString());
        }
    }

    return IdmeCard;
}

export type TIdmeCard = ReturnType<typeof IdmeCardClassCreator>;

export type TIdmeCardInstance = InstanceType<TIdmeCard>;

export default IdmeCardClassCreator;
